import { StyledVerticalScrollFade } from "./fade-vertical-scroll.styles";
import { MDSVerticalScrollFadeProps } from "./fade-vertical-scroll.types";

export const MDSFadeBottom = ({
  visible = true,
  ...rest
}: Omit<MDSVerticalScrollFadeProps, "placement">) => (
  <StyledVerticalScrollFade
    data-mds-name="fade-bottom"
    $placement="bottom"
    $visible={visible}
    aria-hidden
    {...rest}
  />
);
